@if (model$ | async) {
    <div class="card">
        <h5 class="card-header">Site Business Days</h5>
        <table class="table">
            <tbody>
                <tr>
                    <td>
                        <span ngbTooltip="Count of sites with at least one business day set.">
                            {{ businessDayStatusEnum.toDescription(businessDayStatusEnum.BusinessDaysSet) }}
                        </span>
                    </td>
                    <td>
                        <a
                            routerLink="/sites/by-event"
                            [queryParams]="{ businessDayStatus: businessDayStatusEnum.BusinessDaysSet }"
                        >
                            {{ model.businessDaysSetCount }}
                        </a>
                    </td>
                    <td>{{ model.percentSet }}%</td>
                </tr>
                <tr>
                    <td>
                        <span ngbTooltip="Count of sites where business days were never set by an admin.">
                            {{ businessDayStatusEnum.toDescription(businessDayStatusEnum.BusinessDaysNotSet) }}
                        </span>
                    </td>
                    <td>
                        <a
                            routerLink="/sites/by-event"
                            [queryParams]="{ businessDayStatus: businessDayStatusEnum.BusinessDaysNotSet }"
                        >
                            {{ model.businessDaysNotSetCount }}
                        </a>
                    </td>
                    <td>{{ model.percentNotSet }}%</td>
                </tr>
                <tr>
                    <td>
                        <span
                            ngbTooltip="Count of sites where an admin initially set business days, then came back and closed all business days."
                        >
                            {{ businessDayStatusEnum.toDescription(businessDayStatusEnum.SitesClosed) }}
                        </span>
                    </td>
                    <td>
                        <a
                            routerLink="/sites/by-event"
                            [queryParams]="{ businessDayStatus: businessDayStatusEnum.SitesClosed }"
                        >
                            {{ model.sitesClosedCount }}
                        </a>
                    </td>
                    <td>{{ model.percentClosed }}%</td>
                </tr>
            </tbody>
        </table>
    </div>
}
